/* eslint-disable */
import ordersCancelOrder from './Actions/OrderCancellation.action';
import ordersConfirmOrder from './Actions/OrderConfirmation.action';
import orderIdUnselected from './Actions/OrderIdUnselected.action';
import ordersAll from './Actions/OrdersAll.action';
import orderAllAddresses from './Actions/OrdersAllAddresses.action';
import ordersFindById from './Actions/OrdersFindById.action';
import ordersFindByStatus from './Actions/OrdersFindByStatus.action';
import ordersFindLinked from './Actions/OrdersFindLinked.action';

const ordersActionCreators = {
  orderAllAddresses,
  orderIdUnselected,
  ordersAll,
  ordersCancelOrder,
  ordersConfirmOrder,
  ordersFindById,
  ordersFindByStatus,
  ordersFindLinked,
};

export default ordersActionCreators;
